import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './UserEditModal.module.css' 
import Mobile from "../../../../assets/Icon/Mobile";
import At from "../../../../assets/Icon/At";
import Id from "../../../../assets/Icon/Id";
import User from "../../../../assets/Icon/User";  
import Pen from "../../../../assets/Icon/Pen"; 
import { AppContext } from '../../../../providers/appProvider';
import { selectStyle } from './selectStyle';
import Select from "react-select";
import Form from '../../../../assets/Style/Form.module.css'
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { useTranslation } from 'react-i18next';
import RoleLanguage from '../../../UI/RoleLanguage/RoleLanguage';  
import { validatePhoneNumber } from '../../../../utils/phone';

const UserEditModal = ({ userService, defaultUser }) => {
    const {t} = useTranslation();
    
    const [idfont, setIdfont] = useState("null");
    const [idback, setIdback] = useState("null");
    
    const userResetData = {
        id: 0,
        firstname: "",
        lastname: "",
        personal: "",
        email: "",
        password: "",
        mobile: "",
        id_front: "",
        id_back: "",
        is_admin: false,
        role_id: 0,
        saler_id: 0,
        level: 0, 
        companyName: "",
        companyIdentifier: ""  
    }

    const initEditUser = (user) => {
        return {
            id: user.id,
            firstname: user.firstname,
            lastname: user.lastname,
            personal: user.personal, 
            email: user.email, 
            mobile: user.mobile, 
            salary: user.salary, 
            bonus_percent: user.bonus_percent, 
            bonus_max_percent: user.bonus_max_percent, 
            password: "", 
            saler_id: user.saler_id,
            role_id: user.role.id, 
            level: user.level, 
            id_front: user.id_front, 
            id_back: user.id_back, 
            companyName: user.companyName,
            companyIdentifier: user.companyIdentifier  
        }
    }


    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', 
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),

    };
                             
    const [newUser, setNewUser] = useState(userResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const { appState, app } = useContext(AppContext);
    const salers = appState.salers.map((saler) => ({ value: saler.id, label: `${saler.firstname} ${saler.lastname}` }));

    var roles = appState.roles.map((role) => ({ value: role.id,   label: <RoleLanguage role={role.description} /> }));
 
    const findRoleIdByName = (name) => {
        const role = appState.roles.find(role => role.name === name);
        return role ? role.id : 0;
    }

    const findRoleByName = (name) => {
        const role = appState.roles.find(role => role.name === name);
        return role ? role : null;
    }

    const adminRoleId = findRoleIdByName("administrator");
    const salerRoleId = findRoleIdByName("saler");
    const dealerRoleId = findRoleIdByName("dealer");


    const [isCompany, setIsCompany] = useState(!!defaultUser?.companyName);

    

    const handleIsCompanyChange = (event) => {

        setIsCompany(event.target.checked);
      

    };


    const validateUser = (user) => {
        const messages = {};


        if (isCompany) {
            if (user.companyName.length < 2) {
                messages.companyName = { message: 'მიუთითეთ კომპანიის სახელი', isValid: false };
            }
    
            if (user.companyIdentifier.length < 1) {
                messages.companyIdentifier = { message: 'სავალდებულოა', isValid: false };
            }
        } else {
            if (user.firstname.length < 2) {
                messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
            }
    
            if (user.lastname.length < 2) {
                messages.lastname = { message: 'მიუთითეთ გვარი', isValid: false };
            }
    
            if (user.personal.length < 1) {
                messages.personal = { message: 'სავალდებულოა', isValid: false };
            }
        }

 

        if (!user.mobile || !validatePhoneNumber(user.mobile)) {
            messages.mobile = { message: 'ნომერი არასწორია', isValid: false };
        }

        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!user.email || user.email.length === 0 || !emailRegex.test(user.email)) {
            messages.email = { message: 'ელ-ფოსტა არასწორია', isValid: false };
        }

        if (user.role_id < 1) {
            messages.role_id = { message: 'სავალდებულოა', isValid: false };
        }
          
        if (user.role_id === dealerRoleId) {
            if (user.saler_id < 1) {
                messages.saler_id = { message: 'სავალდებულოა', isValid: false };
            }
        }

  
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateUser(newUser)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateUser(newUser)
        }
      }, [newUser, isFirstValidated]);

      useEffect(() => {
        const editedCar = initEditUser(defaultUser)
        setNewUser(editedCar)
    }, [defaultUser]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
         
        const isValidate = validateUser(newUser)

        if (isValidate === true) {

            var userForAdd = {...newUser}


            if (isCompany) {
                // Remove individual fields for company
                delete userForAdd.firstname;
                delete userForAdd.lastname;
                delete userForAdd.personal;
            } else {
                // Remove company fields for individual
                delete userForAdd.companyName;
                delete userForAdd.companyIdentifier;
            }


            if (dealerRoleId !== newUser.role_id) {
                delete userForAdd.saler_id
            }

            if ( (adminRoleId !== newUser.role_id) && (salerRoleId !== newUser.role_id)  ){
                   userForAdd = {
                    ...userForAdd,
                    salary: 0,
                    bonus_percent: 0,
                    bonus_max_percent: 0
                };
            }

            const userToSave = {
                ...newUser,
                level: convertToInt(newUser.level) // Ensure level is an integer
            };

            const newForm = new FormData();
             
            for (let key in userToSave) {
             //   newForm.append(key, userToSave[key]); 
            }

          // newForm.append('idfont', idfont);
           // newForm.append('idback', idback);
           // newForm.append('id', newUser.id);
 
  
            userService.update(userToSave); 

            
            setIsModalOpen(false);
        } else {
            setIsFirstValidated(true) 
        } 
        
    };

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setNewUser(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        })); 
    };

    const handlePhoneChange = (phone) => {
        let val = phone;
        setNewUser(prevClient => ({
            ...prevClient,
            ["mobile"]: val
        }));
 
    };

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }
 
    const handleClientChangeInt = async (event) => {
        let val = event.target.value;
        
        setNewUser(prevClient => ({
            ...prevClient,
            [event.target.name]: convertToInt(val)
        })); 
    };


     
    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false) 
    }

    const setIsAdmin = (isAdmin) => {
        setNewUser(prevClient => ({
            ...prevClient,
            is_admin: isAdmin
        }));
    }

    if(!app.hasPermission("ALL_ROLES_GRANT")) {
        var newRoles = []
  
        if (app.hasPermission("DEALER_ROLE_GRANT")) {
            var dealerRole = findRoleByName("dealer")
  
            if (dealerRole) {
              newRoles.push(dealerRole);
            }
        }
  
        if (app.hasPermission("CLIENT_ROLE_GRANT")) {
          var clientRole = findRoleByName("client")
  
          if (clientRole) {
            newRoles.push(clientRole);
          }
        }
  
        if (app.hasPermission("OPERATOR_ROLE_GRANT")) {
          var operatorRole = findRoleByName("operator")
  
          if (operatorRole) {
            newRoles.push(operatorRole);
          }
        }
  
  
        if (app.hasPermission("ADMINISTRATOR_ROLE_GRANT")) {
          var administratorRole = findRoleByName("administrator")
  
          if (administratorRole) {
            newRoles.push(administratorRole);
          }
        }
  
  
        if (app.hasPermission("SALER_ROLE_GRANT")) {
          var salerRole = findRoleByName("saler")
  
          if (salerRole) {
            newRoles.push(salerRole);
          }
        }
  
        if (app.hasPermission("SUPERADMIN_ROLE_GRANT")) {
          var superadmin = findRoleByName("superadmin")
  
          if (superadmin) {
            newRoles.push(superadmin);
          }
        }
  
  
        roles = newRoles.map((role) => ({ value: role.id,   label: <RoleLanguage role={role.description} /> }))
      }     

  
    return (
        <div>

            <span className={ cl.editBtn } onClick={() => openAdd()} >
                <Pen/> {t('Update')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
 
                <div className={cl.modalHead} >
                    <h3>
                    <span className={cl.iconHead} > <Pen /></span> {t('Update')}
                    </h3>
                </div>




                {!isCompany ? (
                    <>
 
                        <div className={cl.inp2col}>

                            <div className={cl.groupInput}>
                                <div className={cl.groupInputIcon}>
                                    <input type="textS" className={validates && validates.firstname ? cl.input + ' ' +  cl.errorInput : cl.input  } placeholder={t('Firstname')} name="firstname" value={newUser.firstname} onChange={handleClientChange} autoComplete="off"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase(); 
                                    }}
                                    />
                                    <div className={cl.crmIcon}><User /></div>
                                </div>
                            </div>

                            <div className={cl.groupInput}>
                                <div className={cl.groupInputIcon}>
                                    <input type="textS" className={validates && validates.lastname ? cl.input + ' ' +  cl.errorInput : cl.input } placeholder={t('Lastname')} name="lastname" value={newUser.lastname} onChange={handleClientChange} autoComplete="off" 
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase(); 
                                    }}
                                    />
                                    <div className={cl.crmIcon}><User /></div>
                                </div>
                            </div>

                        </div>


                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS" className={validates && validates.personal ? cl.input + ' ' +  cl.errorInput : cl.input } 
                                placeholder={t('PersonalNumber')} name="personal" value={newUser.personal} onChange={handleClientChange} autoComplete="off" 
                                onInput={(e) => {
    
                                    if (e.target.value.length > 11) { 
                                        e.target.value = e.target.value.substring(0, 11);
                                    }
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();

                                }}
                                />
                                <div className={cl.crmIcon}><Id /></div>
                            </div>
                            {validates && validates.personal &&
                                <div className={ cl.errorMsg } >{validates.personal.message}</div>}
                        </div>
                             
                    </>
                ) : (
                    <>

                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS" className={validates && validates.companyName ? cl.input + ' ' +  cl.errorInput : cl.input  } placeholder={t('CompanyName')} name="companyName" value={newUser.companyName} onChange={handleClientChange} autoComplete="off"
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase(); 
                                }}
                                />
                                <div className={cl.crmIcon}><User /></div>
                            </div>
                            {validates && validates.companyName &&
                                <div className={ cl.errorMsg } >{validates.companyName.message}</div>}
                        </div>

                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS" className={validates && validates.companyIdentifier ? cl.input + ' ' +  cl.errorInput : cl.input } placeholder={t('CompanyIdentifier')} name="companyIdentifier" value={newUser.companyIdentifier} onChange={handleClientChange} autoComplete="off" 
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase(); 
                                }}
                                />
                                <div className={cl.crmIcon}><Id /></div>
                            </div>
                            {validates && validates.companyIdentifier &&
                                <div className={ cl.errorMsg } >{validates.companyIdentifier.message}</div>}
                        </div>      
 
                    </>
                )}


   
  
                    <div className={cl.inp2col2} style={{ marginBottom: 0 }}>
                        <div className={validates && validates.mobile ? cl.groupInput + ' errorInput'  : cl.groupInput}>
                            <PhoneInput
                                defaultCountry="ge"
                                value={newUser.mobile}
                                defaultMask="... ...-..."
                                hideDropdown={false}
                                name="mobile"
                                onChange={(phone) => handlePhoneChange(phone)}
                            />
                            
                            {validates && validates.mobile &&
                            <div className={ cl.errorMsg } >{validates.mobile.message}</div>}
                        </div>

                        <div className={cl.groupInput}>
                            <div className={cl.groupInputIcon}>
                                <input type="textS" className={validates && validates.email ? cl.input + ' ' +  cl.errorInput : cl.input } 
                                placeholder={t('Email')}
                                name="email" value={newUser.email} 
                                onChange={handleClientChange}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9.@\-_]/g, '').toUpperCase();
                                }} 
                                 autoComplete="off" />
                                <div className={cl.crmIcon}>
                                    <At />
                                </div>
                            </div>
                            {validates && validates.email &&
                            <div className={ cl.errorMsg } >{validates.email.message}</div>}
                        </div> 
                    </div> 
 

                    <div className={cl.groupInput}> 
                        <label>{t('Role')}</label>
                        <Select
                            styles={validates && validates.role_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={roles}
                            placeholder={t('Role')}
                            value={roles.find(option => option.value === newUser.role_id)}
                            onChange={(selectedOption) => {
                                setNewUser(prevState => ({
                                    ...prevState,
                                    role_id: selectedOption ? selectedOption.value : 0,
                                }));
                            }}
                        /> 
                    </div>


                  

                    { app.hasPermission("USER_SALARY_SHOW") && newUser.role_id === 2   &&   
                    <>
                        <div className={ cl.groupPrice }>
                            <label className={ cl.leftLabel }>{t('Salary')}</label>
                            <div className={ cl.rightInput }>
                                <div className={ Form.priceInput }> 
                                    <div className={ Form.priceCurrency }> 
                                        GEL
                                    </div>
                                    <input type="text" name="salary" className={ Form.input } value={newUser.salary} onChange={handleClientChangeInt} min="0"/>
                                    <div className={ Form.hundred } >.00</div>
                                </div>
                            </div>
                        </div>


                        <div className={ cl.groupPrice }>
                            <label className={ cl.leftLabel }>{t('Bonus')}</label>
                            <div className={ cl.rightInput }>
                                <div className={ Form.priceInput }> 
                                    <div className={ Form.priceCurrency }> 
                                        %
                                    </div>
                                    <input type="text" name="bonus_percent" className={ Form.input } value={newUser.bonus_percent} onChange={handleClientChangeInt} min="0"/>
                                    <div className={ Form.hundred } >.00</div>
                                </div>
                            </div>
                        </div>


                        <div className={ cl.groupPrice }>
                            
                            <label className={ cl.leftLabel }>Max {t('Bonus')}</label>
                            <div className={ cl.rightInput }>
                                <div className={ Form.priceInput }> 
                                    <div className={ Form.priceCurrency }> 
                                        %
                                    </div>
                                    <input type="text" name="bonus_max_percent" className={ Form.input }  value={newUser.bonus_max_percent} onChange={handleClientChangeInt} min="0"/>
                                    <div className={ Form.hundred } >.00</div>
                                </div>
                            </div>
                        </div>
                    </>
                }

{dealerRoleId === newUser.role_id &&
                    <>
                        <div className={cl.groupInput}>
                            <label>{t('Saler')}</label>
                            <Select
                                styles={validates && validates.saler_id ? { ...selectStyle, ...stylesError } : selectStyle}
                                options={salers}
                                placeholder={t('Saler')}
                                value={salers.find(option => option.value === newUser.saler_id)}
                                onChange={(selectedOption) => {
                                    setNewUser(prevState => ({
                                        ...prevState,
                                        saler_id: selectedOption ? selectedOption.value : 0,
                                    }));
                                }}
                            />
                        </div>
                    </>
                }

                <div className={cl.groupInput}>
                    <label>{t('Level')}</label>
                    <Select
                        styles={selectStyle}
                        options={[
                            { value: 0, label: "0" },
                            { value: 1, label: "1" },
                            { value: 2, label: "2" },
                            { value: 3, label: "3" },
                            { value: 4, label: "4" },
                            { value: 5, label: "5" }
                        ]}
                        placeholder={t('Level')}
 
                        value={{
                            value: newUser.level,
                            label: newUser.level?.toString?.() || ''
                        }}

                        onChange={(selectedOption) => {
                            setNewUser(prevState => ({
                                ...prevState,
                                level: selectedOption ? selectedOption.value : 0
                            }));
                        }}
                    />
                </div>

                <div className={cl.groupInput}>
                    <label>
                        <input
                            type="checkbox"
                            checked={isCompany}
                            onChange={handleIsCompanyChange}
                        />
                        <b>{t('Company')}</b>
                    </label>
                </div>


                {/* 
                    <div className={cl.groupInput}> 
                        <label>{t('IDFront')}</label>
                        <input type="file" name="id_front" className={Form.input} onChange={e => setIdfont(e.target.files[0])} />

                    </div>

                    <div className={cl.groupInput}> 
                        <label>{t('IDBack')}</label>
                        <input type="file" name="id_back" className={Form.input} onChange={e => setIdback(e.target.files[0])} />

                    </div>

                */}

 
                <span onClick={saveHandle} className={cl.btnPrimary}>{t('Save')}</span> 
            </Modal>
        </div>
    );
};

export default UserEditModal;